import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { LoanStatus } from '@/types';

export function useBulkTransitionStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { loanIds: string[]; status: LoanStatus; reason?: string }) =>
      api.post('/loans/bulk/status', body).then(r => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['loans'] });
    },
  });
}

export function useBulkAssign() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { loanIds: string[]; userId: string; role?: string }) =>
      api.post('/loans/bulk/assign', body).then(r => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['loans'] });
    },
  });
}

export function useBulkExport() {
  return useMutation({
    mutationFn: (body: { loanIds: string[] }) =>
      api.post('/loans/bulk/export', body).then(r => r.data),
  });
}
